/**
 * [Webtoon Auto Save Module]
 * Handles 3-second debounce logic for silent auto-saving in Webtoon Editor.
 * Adapts strict "Module Pattern" to keep Editor Clean.
 */
export const WebtoonAutoSave = {
    /**
     * Initialize Auto Save Listener
     * @param {Function} saveCallback - The function to call when saving (async)
     * @param {HTMLElement} container - The container to listen for events on
     * @param {number} interval - Debounce interval in ms (default 3000)
     * @returns {Function} cleanup - Function to remove listeners
     */
    init(saveCallback, container, interval = 3000) {
        let timer = null;

        const trigger = (e) => {
            // Ignore non-content changes if needed, but for now capture all input
            if (timer) clearTimeout(timer);
            timer = setTimeout(() => {
                console.log("[WebtoonAutoSave] Triggering...");
                saveCallback();
            }, interval);
        };

        // DOM Events to Listen
        // 1. Inputs (Title, Meta, etc)
        container.addEventListener('input', trigger);

        // 2. Change (File Inputs, Selects)
        container.addEventListener('change', trigger);

        // 3. Sortable Events (We need to attach this manually or expose a trigger method)
        // Since Sortable is internal to the Editor, the Editor should call trigger() manually
        // OR we expose a .trigger() method.

        console.log("[WebtoonAutoSave] Initialized");

        const manualTrigger = () => trigger();

        return {
            cleanup: () => {
                if (timer) clearTimeout(timer);
                container.removeEventListener('input', trigger);
                container.removeEventListener('change', trigger);
                console.log("[WebtoonAutoSave] Destroyed");
            },
            trigger: manualTrigger
        };
    }
};
